import { Icon } from "./Icon"
import { BookingSummaryContent, type BookingSummaryData } from "./BookingSummaryContent"

export function BookingSummary({ summary, onEdit, showReassurance = false, totalLabel }: { summary: BookingSummaryData | null; onEdit?: () => void; showReassurance?: boolean; totalLabel?: string }) {
    if (!summary) return null

    return <section className="ah-panel ah-summary-card" aria-label="Booking summary">
        <div className="ah-summary-title">
            <div className="ah-eyebrow">BOOKING SUMMARY</div>
            {onEdit && <button type="button" className="ah-summary-edit" aria-label="Edit booking" onClick={onEdit}>Edit</button>}
        </div>
        <div className="ah-summary-product"><img src={summary.image} alt="" /><div><h3>{summary.productName}</h3><span>Quantity {summary.quantity}</span></div></div>
        <BookingSummaryContent summary={summary} layout="sidebar" totalLabel={totalLabel} />
        {showReassurance && <ul className="ah-summary-reassurance" aria-label="Booking reassurance">
            <li><Icon name="check" /><span>Trusted by 100+ customers nationwide</span></li>
            <li><Icon name="truck" /><span>Delivering 7 days a week</span></li>
            <li><Icon name="lock" /><span>Secure payment with Stripe</span></li>
        </ul>}
    </section>
}
